<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <div class="collapsable-header">
          <div class="bold mb">Änderungsvorschläge</div>
          <div class="">Verwalte deine Änderungsvorschläge</div>
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <div class="settings-collapsable-list">
          <div
            v-for="(idea, index) in ideas"
            :key="idea.id"
            class="settings-idea-wrapper"
          >
            <div class="settings-idea-item">
              <div class="setting-title">{{ idea.title }}</div>
              <div class="icon-block">
                <div class="settings-icon">
                  <a :href="'/idee/' + idea.id"
                    ><img src="/img/icons/settings-arrow.svg" />
                  </a>
                </div>
                <div class="settings-icon">
                  <a :href="'/idee-editieren/edit/' + idea.id"
                    ><img src="/img/icons/edit.svg" />
                  </a>
                </div>
                <!-- <div class="settings-icon">
                  <button>
                    <img src="/img/icons/trash.svg" />
                  </button>
                </div> -->
              </div>
            </div>
            <div v-if="index < ideas.length-1" class="settings-divider"></div>
          </div>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  props: ["ideasIncoming"],
  data() {
    return {
      ideas: this.ideasIncoming,
      errorMessage: null,
      successMessage: null,
    };
  },
  watch: {},
  methods: {
    changeEmail() {
      this.errorMessage = null;
      this.successMessage = null;
      axios
        .post("/changeMail", {
          email: this.email,
        })
        .then((res) => {
          console.log(res);
          this.successMessage =
            "Deine E-Mail Adresse wurde erfolgreich geändert.";
        })
        .catch((error) => {
          console.log(error.response);

          if (error.response.status === 422) {
            this.errorMessage = error.response.data.errors.email[0];
          } else {
            this.errorMessage = "Es ist ein Fehler aufgetreten.";
          }
        });
    },
  },
  mounted() {},
  created() {},
  computed: {},
};
</script>

<style>
</style>
